import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  console.log(params);
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/workshop/workshop_spare_part_prices`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_spare_part_prices/${id}`, options)
    .then(response => {
      let spare_part_prices = jsona.deserialize(response.data);
      delete spare_part_prices.links;
      return spare_part_prices;
    });
}

function add(spare_part_prices) {
  
  console.log(spare_part_prices);
  const payload = jsona.serialize({
    stuff: spare_part_prices,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/workshop/workshop_spare_part_prices`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(spare_part_prices) {
  const payload = jsona.serialize({
    stuff: spare_part_prices,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_spare_part_prices/${spare_part_prices.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_spare_part_prices/${id}`, options);
}

function list_price_master_id(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };
  

  return axios.get(`${url}/workshop/workshop_spare_part_prices?filter[spare_part_price_master_id]=${id}`, options)
  .then(response => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta
    };
  });
}

function list_lowest_price_master_id(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };
  

  return axios.get(`${url}/workshop/workshop_spare_part_prices?filter[lower_price]=${id}`, options)
  .then(response => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta
    };
  });
}


function list_price_dealer_id(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_spare_part_prices?filter[spare_part_price_dealer_id]=${id}`, options)
  .then(response => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta
    };
  });
}


export default {
  list,
  list_price_master_id,
  list_lowest_price_master_id,
  list_price_dealer_id,
  get,
  add,
  update,
  destroy
};

